// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__ZjySy","footer":"ModalInfo_footer__18xRS"};